/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Limits
 */
export interface Limits {
    /**
     * Total Money-In number allowed for this account
     * @type {number}
     * @memberof Limits
     */
    totalMoneyInAllowed?: number;
    /**
     * Total Money-In amount allowed for this wallet
     * @type {number}
     * @memberof Limits
     */
    amountMoneyInAllowed?: number;
}

/**
 * Check if a given object implements the Limits interface.
 */
export function instanceOfLimits(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LimitsFromJSON(json: any): Limits {
    return LimitsFromJSONTyped(json, false);
}

export function LimitsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Limits {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalMoneyInAllowed': !exists(json, 'totalMoneyInAllowed') ? undefined : json['totalMoneyInAllowed'],
        'amountMoneyInAllowed': !exists(json, 'amountMoneyInAllowed') ? undefined : json['amountMoneyInAllowed'],
    };
}

export function LimitsToJSON(value?: Limits | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalMoneyInAllowed': value.totalMoneyInAllowed,
        'amountMoneyInAllowed': value.amountMoneyInAllowed,
    };
}

